import { SYSTEM_EVENTS } from "../../events/events";
import Event from '../../utils/event';
import ToasterBaseComponent from "../../base/toaster_base_component";
import { BaseComponentParams } from '../../base/base_component_interface';

const VIEW = require('./view/blue_ribbon_jp_status.html');

interface BlueRibbonJackpotStatusComponentParams extends BaseComponentParams {
    jackPotValue: number;
}

export default class BlueRibbonJackpotStatusComponent extends ToasterBaseComponent {
    private _initialParams: BlueRibbonJackpotStatusComponentParams;

    init(params: BlueRibbonJackpotStatusComponentParams) {
        this._initialParams = params;
        super.init(params);
        this._bakeContent();
    }

    _bakeContent() {
        const title = this.translate('br_status_title', {});
        const subTitle = this.translate('br_status_subtitle', {amount: ''});
        const value = this.serviceFactory.currencyService().formatMoney(this._initialParams.jackPotValue);
        const content = this.bake(VIEW, {
            title: title,
            subtitle: subTitle,
            value: value
        });
        this.setHTML(content);
    }

    _onOpened() {
        this._sendAnalytics({action: 'blue_ribbon_toaster_view'});
    }

    _onClicked() {
        this._sendAnalytics({action: 'blue_ribbon_toaster_click'});
        this.closeToaster();
        this.serviceFactory.blueRibbonService().showPersonalJackpotPromotionPage();
    }

    _onClosed() {
        this._sendAnalytics({action: 'blue_ribbon_toaster_close'});
    }

    _sendAnalytics(analyticsData: {action: string}): void{
        const analyticsObject = {
            category: 'Personal_Jackpot',
            label: this._initialParams.jackPotValue
        };

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, Object.assign(analyticsObject, analyticsData));
    }
}
